import { render, staticRenderFns } from "./IntentDetailsTraining.vue?vue&type=template&id=0fe4c912"
import script from "./IntentDetailsTraining.vue?vue&type=script&lang=js"
export * from "./IntentDetailsTraining.vue?vue&type=script&lang=js"
import style0 from "./IntentDetailsTraining.vue?vue&type=style&index=0&id=0fe4c912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports